







































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
    defaultFullDocument,
    FullDocument,
} from '@/types/front-data-types/full-docs';

import Avatar from '@/components/block/avatar.vue';

@Component({ name: 'ArButtonDocumentChoose', components: { Avatar } })
export default class ArButtonDocumentChoose extends Vue {
    @Prop({ default: defaultFullDocument }) readonly document: FullDocument;
    @Prop({ default: false }) readonly isChosen: boolean;
    @Prop({ default: false }) readonly isBookCard: boolean;

    @Emit('addToChosen')
    addToChosen(): boolean {
        return true;
    }
}
